import PersonalIdentity from './components/forms/personal-identity';
import FamilyInformation from './components/forms/family-information';
import Financial from './components/forms/financial';
import Review from './components/forms/review';

export const ApplicationForms = [
  PersonalIdentity,
  FamilyInformation,
  Financial,
  Review,
];
